// import axios from "axios";
import api from "../api";
export default {
  state: {
    nodos: [],
  },
  getters: {
    nodos(state) {
      return state.nodos;
    },
  },
  mutations: {
    get_nodos(state, nodos) {
      if (typeof nodos.length !== "undefined") {
        state.nodos = nodos;
      }
      return state.nodos;
    },
  },
  actions: {
    get_nodos(context) {
      if (context.getters["auth/loggedIn"]) {
        return new Promise((resolve, reject) => {
          // let api = api(context);
          api(context).get("/nodo")
            .then((response) => {
              context.commit("get_nodos", response.data.arbol);
              resolve(response.data.arbol);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    },
  },
};
